import React from 'react';
import { useIntl } from "react-intl";
import { useQuery } from 'react-query';
import axios from 'axios';

const Plays: React.FC<{ presentation_id: string }> = ({ presentation_id }) => {
    const intl = useIntl();

    const { data, isLoading, error } = useQuery(['views', presentation_id], async () => {
        const response = await axios.get<any>(
          `${process.env.REACT_APP_API_ENDPOINT}/api/presentation/${presentation_id}/plays`);
        return response.data;
    }, {
        enabled: presentation_id ? true : false,
    });

    if (isLoading) return <span className="views"><i>loading</i></span>

    return <span className="views"><img src="/icons/eye-ico.svg" alt="eye" /> <span>{error ? 0 : data.data}</span> {intl.formatMessage({ id: 'views' })}</span>
}

export default Plays;
